import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import { PhysicalAddress } from 'owa-location-service';

export default function toPhysicalAddress(postalAddress: PersonaPostalAddress): PhysicalAddress {
    if (!postalAddress) {
        return undefined;
    }

    return {
        Street: postalAddress.Street,
        City: postalAddress.City,
        State: postalAddress.State,
        CountryOrRegion: postalAddress.Country,
        PostalCode: postalAddress.PostalCode,
    };
}
